import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
import ProgrammeTtf from '../Fonts/Programme-Regular.ttf';
/*import ProgrammeItalicTtf from '../fonts/Programme-RegularItalic.ttf';
import ProgrammeBoldTtf from '../fonts/Programme-Bold.ttf';
import ProgrammeBoldItalicTtf from '../fonts/Programme-BoldItalic.ttf';
import ProgrammeLightTtf from '../fonts/Programme-Light.ttf';
import ProgrammeLightItalicTtf from '../fonts/Programme-LightItalic.ttf';*/


const programme = {
  fontFamily: 'Programme',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Programme'),
    local('Programme-Regular'),
    url(${ProgrammeTtf}) format('truetype')
  `,
  unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const secondTheme = createMuiTheme({
  direction:"ltr",
  overrides: {   
    MuiCssBaseline: {
      '@global': {
        '@font-face': [programme],
        body: {
          height:"100%",
          overflow: "auto",
          //backgroundColor: "#F24949",
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='150 -100 780 533.08'%3E%3Cg data-name='Layer 2'%3E%3Cg data-name='Layer 1'%3E%3Cpath d='M728.63 433.08h.29l16.3-19.83C628.26 328 597.88 51.32 597.88 51.32L526.92 0v433.08h19.61l84.52-102.83 30.74-7.65 4.36 72.7 63 37.4z' fill='%23243770'/%3E%3Cpath d='M836.35 44.51L634.21 12.94c.38 49.41-7.82 92.48-20.73 129.6 16.81 77.9 49.23 186.82 106.68 248.3C837.27 296.86 836.35 44.51 836.35 44.51z' fill='%23e7422c'/%3E%3Cpath d='M479.37 324.15l4.36 72.69 43.19 25.65V0L456 51.32s-15 136.7-64.55 247.53a449.85 449.85 0 0032.53 63l24.69-30z' fill='%23263d8a'/%3E%3Cpath d='M183 433.08l83.2-101.29 22.44-5.58c35.31-79.44 46.65-159.85 46.65-159.85L226.88 146.1C176.11 393.57 31.38 428.4 0 433.08z' fill='%23f6b1a6'/%3E%3Cpath fill='%23243770' d='M362.31 433.08l-61-36.24-4.36-72.69-30.75 7.65v75.12l20.93 26.16h75.18z'/%3E%3Cpath fill='%23263d8a' d='M182.96 433.08h104.17l-20.93-26.16V331.8l-83.24 101.28z'/%3E%3Cpath fill='%2364bbaf' d='M365.38 433.08h104.17l-20.92-26.16V331.8l-83.25 101.28z'/%3E%3Cpath fill='%23e7422c' d='M546.53 433.08h106.68l-22.16-27.7v-75.13l-84.52 102.83z'/%3E%3Cpath fill='%23cd3829' d='M728.63 433.08l.48-.38-62.96-37.4-4.36-72.7-30.74 7.65v75.13l22.16 27.7h75.42z'/%3E%3Cpath fill='%23efaa1f' d='M728.92 433.08h110.37l-23.98-29.98v-75.13l-86.39 105.11z'/%3E%3Cpath fill='%23d09433' d='M909.99 433.08h7.86l-67.44-40.06-4.36-72.7-30.74 7.65v75.13l23.98 29.98h70.7z'/%3E%3Cpath d='M301.31 396.84l61 36.24h3.07l58.56-71.25c-52.49-83.51-69.45-184.67-69.45-184.67l-19.2-10.8S324 246.75 288.64 326.21l8.31-2.06z' fill='%23db9d96'/%3E%3Cpath fill='%2357a093' d='M544.73 433.08l-61-36.24-4.36-72.69-30.74 7.65v75.12l20.92 26.16h75.18z'/%3E%3Cpath d='M745.23 413.23L815.31 328l30.74-7.65 4.36 72.7 67.44 40.06H980c-16.28-16.93-76-96.82-76-358.61l-67.68-30s-6.13 251.72-116.57 345.92a177.15 177.15 0 0025.48 22.81z' fill='%23cd3829'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",

          //backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='150 -100 780 533.08'%3E%3Cdefs/%3E%3Cg data-name='Layer 2'%3E%3Cg data-name='Layer 1'%3E%3Cpath d='M836.35 44.51L634.21 12.94c.38 49.41-7.82 92.48-20.73 129.6 16.81 77.9 49.23 186.82 106.68 248.3C837.27 296.86 836.35 44.51 836.35 44.51z' style='fill:%23c32026'/%3E%3Cpath d='M479.37 324.15l4.36 72.69 43.19 25.65V0L456 51.32s-15 136.7-64.55 247.53a449.85 449.85 0 0032.53 63l24.69-30z' style='fill:%23cd1a6f'/%3E%3Cpath d='M728.63 433.08h.29l16.3-19.83C628.26 328 597.88 51.32 597.88 51.32L526.92 0v433.08h19.61l84.52-102.83 30.74-7.65 4.36 72.7 63 37.4z' style='fill:%23a71e5b'/%3E%3Cpath d='M183 433.08l83.2-101.29 22.44-5.58c35.31-79.44 46.65-159.85 46.65-159.85L226.88 146.1C176.11 393.57 31.38 428.4 0 433.08z' style='fill:%239d3393'/%3E%3Cpath style='fill:%23aa1e28' d='M362.31 433.08l-61-36.24-4.36-72.69-30.75 7.65v75.12l20.93 26.16h75.18z'/%3E%3Cpath style='fill:%23ce2031' d='M182.96 433.08h104.17l-20.93-26.16V331.8l-83.24 101.28z'/%3E%3Cpath style='fill:%23d01e4f' d='M365.38 433.08h104.17l-20.92-26.16V331.8l-83.25 101.28z'/%3E%3Cpath style='fill:%239d3393' d='M546.53 433.08h106.68l-22.16-27.7v-75.13l-84.52 102.83z'/%3E%3Cpath style='fill:%23832884' d='M728.63 433.08l.48-.38-62.96-37.4-4.36-72.7-30.74 7.65v75.13l22.16 27.7h75.42z'/%3E%3Cpath style='fill:%23bd1a8d' d='M728.92 433.08h110.37l-23.98-29.98v-75.13l-86.39 105.11z'/%3E%3Cpath style='fill:%239a2274' d='M909.99 433.08l3.39-2.66-62.97-37.4-4.36-72.7-30.74 7.65v75.13l23.98 29.98h70.7z'/%3E%3Cpath d='M301.31 396.84l61 36.24h3.07l58.56-71.25c-52.49-83.51-69.45-184.67-69.45-184.67l-19.2-10.8S324 246.75 288.64 326.21l8.31-2.06z' style='fill:%23832884'/%3E%3Cpath style='fill:%23ac1d41' d='M544.73 433.08l-61-36.24-4.36-72.69-30.74 7.65v75.12l20.92 26.16h75.18z'/%3E%3Cpath d='M745.23 413.23L815.31 328l30.74-7.65 4.36 72.7 63 37.4-3.41 2.63h70c-16.28-16.93-76-96.82-76-358.61l-67.68-30s-6.13 251.72-116.57 345.92a177.15 177.15 0 0025.48 22.84z' style='fill:%23a11d21'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
          backgroundAttachment: "fixed",
          backgroundSize: "100% 50%",
          backgroundRepeat:"no-repeat",
          backgroundPosition:"left bottom",
          //backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 200 200'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='100' y1='33' x2='100' y2='-3'%3E%3Cstop offset='0' stop-color='%23000' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23000' stop-opacity='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='100' y1='135' x2='100' y2='97'%3E%3Cstop offset='0' stop-color='%23000' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23000' stop-opacity='1'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg fill='%23ce3e3e' fill-opacity='0.6'%3E%3Crect x='100' width='100' height='100'/%3E%3Crect y='100' width='100' height='100'/%3E%3C/g%3E%3Cg fill-opacity='0.5'%3E%3Cpolygon fill='url(%23a)' points='100 30 0 0 200 0'/%3E%3Cpolygon fill='url(%23b)' points='100 100 0 130 0 100 200 100 200 130'/%3E%3C/g%3E%3C/svg%3E\")",
        },
        html:{height:"100%",overflow:"hidden"},
      },
    },
    
  },
  palette: {
    common: {
      black: "#000",
      white: "#fff"
    },
    type: "dark",
    primary:{
      light: "#64BAAF",
      main: "#0097a7",
      dark:"#F6B1A6",
      contrastText: "#fff"
    },
    secondary:{
      light:"#213B8B",
      main: "#f44336",
      dark: "#ff80ab",
      contrastText: "#fff"
    },
    error: {
      light: "#e57373",
      main: "#f44336",
      dark: "#d32f2f",
      contrastText: "#fff"
    },
    warning: {
      light: "#ffb74d",
      main: "#ff9800",
      dark: "#f57c00",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    info: {
      light: "#64b5f6",
      main: "#2196f3",
      dark: "#1976d2",
      contrastText: "#fff",
    },
    success: {
      light: "#81c784",
      main: "#4caf50",
      dark: "#388e3c",
      contrastText: "rgba(0, 0, 0, 0.87)"
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161",
    },
    text: {
      primary:"#fff",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      hint: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)",
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#424242",
      default: "#303030",
    },
    action: {
      active: "#fff",
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: "0.08",
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: "0.16",
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: "0.38",
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: "0.12",
      activatedOpacity: "0.24"
    },
    props: {}
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 300,
      fontSize: "6rem",
      lineHeight: 1.167,
      letterSpacing: "-0.01562em"
    },
    h2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 300,
      fontSize: "3.75rem",
      lineHeight: 1.2,
      letterSpacing: "-0.00833em"
    },
    h3: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "3rem",
      lineHeight: 1.167,
      letterSpacing: "0em",
    },
    h4: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "2.125rem",
      lineHeight: 1.235,
      letterSpacing: "0.00735em"
    },
    h5: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "1.5rem",
      lineHeight: 1.334,
      letterSpacing: "0em"
    },
    h6: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      fontSize: "1.25rem",
      lineHeight: 1.6,
      letterSpacing: "0.0075em"
    },
    subtitle1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.75,
      letterSpacing: "0.00938em"
    },
    subtitle2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.57,
      letterSpacing: "0.00714em",
    },
    body1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: "0.00938em",
    },
    body2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.43,
      letterSpacing: "0.01071em",
    },
    button: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.75,
      letterSpacing: "0.02857em",
      textTransform: "uppercase",
    },
    caption: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 1.66,
      letterSpacing: "0.03333em"
    },
    overline: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 2.66,
      letterSpacing: "0.08333em",
      textTransform: "uppercase",
    },
  },

  shape: {
    borderRadius: 4,
  },
  transitions: {
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
})
// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    common:{
        black:"#000",
        white:"#fff"
    },
    background:{
        paper:"#fff",
        default:"#fafafa"
    },
    primary:{
        light:"#7986cb",
        main:"#3f51b5",
        dark:
        "#303f9f",
        contrastText:"#fff"
    },
    secondary:{
      light:"#7986cb",main:"#3f51b5",dark:"#303f9f",contrastText:"#fff"
    },
        error:{
          light:"#e57373",main:"#f44336",dark:"#d32f2f",contrastText:"#fff"
        },
        text:{
            primary:"rgba(0, 0, 0, 0.87)",
            secondary:"rgba(0, 0, 0, 0.54)",
            disabled:"rgba(0, 0, 0, 0.38)",
            hint:"rgba(0, 0, 0, 0.38)"
        }
  },
    typography: {
      fontFamily: 'Programme, Arial',
    },
    overrides: {   
      MuiCssBaseline: {
        '@global': {
          '@font-face': [programme],
          body: {
            height:"100%",
            overflow: "auto",
            //backgroundColor: "#F24949",
            
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='150 -100 780 533.08'%3E%3Cdefs/%3E%3Cg data-name='Layer 2'%3E%3Cg data-name='Layer 1'%3E%3Cpath d='M836.35 44.51L634.21 12.94c.38 49.41-7.82 92.48-20.73 129.6 16.81 77.9 49.23 186.82 106.68 248.3C837.27 296.86 836.35 44.51 836.35 44.51z' style='fill:%23c32026'/%3E%3Cpath d='M479.37 324.15l4.36 72.69 43.19 25.65V0L456 51.32s-15 136.7-64.55 247.53a449.85 449.85 0 0032.53 63l24.69-30z' style='fill:%23cd1a6f'/%3E%3Cpath d='M728.63 433.08h.29l16.3-19.83C628.26 328 597.88 51.32 597.88 51.32L526.92 0v433.08h19.61l84.52-102.83 30.74-7.65 4.36 72.7 63 37.4z' style='fill:%23a71e5b'/%3E%3Cpath d='M183 433.08l83.2-101.29 22.44-5.58c35.31-79.44 46.65-159.85 46.65-159.85L226.88 146.1C176.11 393.57 31.38 428.4 0 433.08z' style='fill:%239d3393'/%3E%3Cpath style='fill:%23aa1e28' d='M362.31 433.08l-61-36.24-4.36-72.69-30.75 7.65v75.12l20.93 26.16h75.18z'/%3E%3Cpath style='fill:%23ce2031' d='M182.96 433.08h104.17l-20.93-26.16V331.8l-83.24 101.28z'/%3E%3Cpath style='fill:%23d01e4f' d='M365.38 433.08h104.17l-20.92-26.16V331.8l-83.25 101.28z'/%3E%3Cpath style='fill:%239d3393' d='M546.53 433.08h106.68l-22.16-27.7v-75.13l-84.52 102.83z'/%3E%3Cpath style='fill:%23832884' d='M728.63 433.08l.48-.38-62.96-37.4-4.36-72.7-30.74 7.65v75.13l22.16 27.7h75.42z'/%3E%3Cpath style='fill:%23bd1a8d' d='M728.92 433.08h110.37l-23.98-29.98v-75.13l-86.39 105.11z'/%3E%3Cpath style='fill:%239a2274' d='M909.99 433.08l3.39-2.66-62.97-37.4-4.36-72.7-30.74 7.65v75.13l23.98 29.98h70.7z'/%3E%3Cpath d='M301.31 396.84l61 36.24h3.07l58.56-71.25c-52.49-83.51-69.45-184.67-69.45-184.67l-19.2-10.8S324 246.75 288.64 326.21l8.31-2.06z' style='fill:%23832884'/%3E%3Cpath style='fill:%23ac1d41' d='M544.73 433.08l-61-36.24-4.36-72.69-30.74 7.65v75.12l20.92 26.16h75.18z'/%3E%3Cpath d='M745.23 413.23L815.31 328l30.74-7.65 4.36 72.7 63 37.4-3.41 2.63h70c-16.28-16.93-76-96.82-76-358.61l-67.68-30s-6.13 251.72-116.57 345.92a177.15 177.15 0 0025.48 22.84z' style='fill:%23a11d21'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
            backgroundAttachment: "fixed",
            backgroundSize: "100% 50%",
            backgroundRepeat:"no-repeat",
            backgroundPosition:"left bottom",
            //backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 200 200'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='100' y1='33' x2='100' y2='-3'%3E%3Cstop offset='0' stop-color='%23000' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23000' stop-opacity='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='100' y1='135' x2='100' y2='97'%3E%3Cstop offset='0' stop-color='%23000' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%23000' stop-opacity='1'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg fill='%23ce3e3e' fill-opacity='0.6'%3E%3Crect x='100' width='100' height='100'/%3E%3Crect y='100' width='100' height='100'/%3E%3C/g%3E%3Cg fill-opacity='0.5'%3E%3Cpolygon fill='url(%23a)' points='100 30 0 0 200 0'/%3E%3Cpolygon fill='url(%23b)' points='100 100 0 130 0 100 200 100 200 130'/%3E%3C/g%3E%3C/svg%3E\")",
          },
          html:{height:"100%",overflow:"hidden"},
        },
      },
      
    },
});

export default secondTheme;